import React, { Component } from "react";
import ProvidersTable from './ProvidersTable';
import MobileProvidersTable from './MobileProvidersTable';
import $ from 'jquery';

class TestZipcodeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            displayErrors: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!event.currentTarget.checkValidity()) {
            this.setState({ displayErrors: true });
            return;
        }

        this.setState({ displayErrors: false });
        let self = this;
        let url = `https://apichannellocator.crownmediadev.com/api/snlkChannelLocator?zipcode=${this.refs.zipcode.value}`;
        $.get(url, function (data) {
            self.setState({ data: data });
        });
    }

    render() {
        const { displayErrors } = this.state;
        return (
            <div className="container">
                <div className="">
                    <h3>Enter your zip code to find your local channel number or <a href="#/unavailable">click here</a> to make a channel request</h3>
                    <form noValidate className="zip-form" onSubmit={this.handleSubmit}>
                        <div className={displayErrors ? 'displayErrors form-group' : 'form-group'}>
                            <label htmlFor="inp" className="inp">
                                <input type="text" ref="zipcode" id="inp" placeholder="&nbsp;" required />
                                <span className="label">Zipcode</span>
                                <span className="border"></span>
                            </label>
                        </div>
                    </form>
                    <div>
                        <ProvidersTable channel={this.props.match.params.channel ? this.props.match.params.channel : "hc"} data={this.state.data} />
                        <MobileProvidersTable channel={this.props.match.params.channel ? this.props.match.params.channel : "hc"} data={this.state.data} />
                    </div>
                </div>
            </div>
        );
    }
}

export default TestZipcodeForm;


// WEBPACK FOOTER //
// ./src/components/TestZipcodeForm.js